import * as Sentry from '@sentry/capacitor';
interface IPollParams<T> {
	callback: () => Promise<T>;
	until: (result: T) => boolean;
	ms?: number;
}
export const poll = async <T>({
	callback,
	until,
	ms = 2000,
}: IPollParams<T>): Promise<T | void> => {
	try {
		const result = await callback();
		if (until(result)) {
			await new Promise((resolve) => setTimeout(resolve, ms));
			return await poll({ callback, until, ms });
		}
		return result;
	} catch (error) {
		console.error('Error during polling:', error);
		Sentry.captureException(error);
	}
};
